<app-header-user></app-header-user>

<div class="container pt-4 pb-5">
    <div class="row">
        <div class="col-12">
            <!-- Info box sus -->
            <div class="mb-4">
                <h2>Rezultate investigații și analize</h2>
                <p class="mb-0 text-muted">
                    Vizualizați, descărcați și consultați detalii pentru analize
                    de laborator, imagistică și alte investigații efectuate în
                    cadrul Spitalului CF Pașcani.
                </p>
            </div>

            <!-- TAB 1: Istoric rezultate -->
            <div *ngIf="showHistory">
                <div class="card dashboard-card results-card">
                    <div class="card-header text-white">
                        <div
                            class="d-flex justify-content-between align-items-center"
                        >
                            <h5 class="mb-0">Istoric rezultate medicale</h5>
                            <small *ngIf="results?.length" class="text-light">
                                {{ results.length }} rezultate găsite
                            </small>
                        </div>
                    </div>

                    <div class="card-body">
                        <div
                            *ngIf="loading"
                            class="text-center text-muted py-4"
                        >
                            Se încarcă rezultatele...
                        </div>

                        <div *ngIf="!loading" class="results-table-wrapper">
                            <table class="table results-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Tip rezultat</th>
                                        <th>Categorie</th>
                                        <th>Data</th>
                                        <th>Doctor</th>
                                        <th>Specialitate</th>
                                        <th>Status</th>
                                        <th class="text-end">Acțiuni</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="message">
                                        <td
                                            colspan="7"
                                            class="text-center text-muted"
                                        >
                                            {{ message }}
                                        </td>
                                    </tr>

                                    <tr
                                        *ngFor="
                                            let result of results;
                                            index as i
                                        "
                                        [class.unread-row]="!result.isRead"
                                    >
                                        <td>{{ i + 1 }}</td>
                                        <td>
                                            <div
                                                class="d-flex align-items-center gap-2"
                                            >
                                                <span>
                                                    {{
                                                        (
                                                            result.analysisType ||
                                                            ""
                                                        ).length > 100
                                                            ? (result.analysisType
                                                                  | slice
                                                                      : 0
                                                                      : 100) +
                                                              "..."
                                                            : result.analysisType
                                                    }}
                                                </span>
                                                <span
                                                    *ngIf="!result.isRead"
                                                    class="badge bg-danger badge-pulse"
                                                >
                                                    Nou
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            {{
                                                result.category?.toLowerCase() ===
                                                "radiology"
                                                    ? "Radiologie"
                                                    : result.category?.toLowerCase() ===
                                                      "laboratory"
                                                    ? "Laborator"
                                                    : result.category
                                            }}
                                        </td>

                                        <td>
                                            {{
                                                result.date
                                                    | date: "dd.MM.yyyy"
                                            }}
                                        </td>
                                        <td>{{ result.doctorName }}</td>
                                        <td>
                                            {{ result.senderSpecialisation }}
                                        </td>
                                        <td>
                                            <span
                                                class="badge"
                                                [ngClass]="
                                                    result.status
                                                        ? 'bg-success'
                                                        : 'bg-danger'
                                                "
                                            >
                                                {{
                                                    result.status
                                                        ? "Finalizat"
                                                        : "În lucru"
                                                }}
                                            </span>
                                        </td>
                                        <td class="text-end">
                                            <button
                                                type="button"
                                                class="btn btn-xs btn-outline-info btn-rounded m-1"
                                                (click)="loadDetails(result)"
                                            >
                                                Detalii
                                            </button>
                                            <button *ngIf="result.downloadReference"
                                                type="button"
                                                class="btn btn-xs btn-outline-primary btn-rounded m-1"
                                                (click)="download(result)"
                                            >
                                                Descarcă
                                            </button>
                                            <button *ngIf="result.downloadReference"
                                                type="button"
                                                class="btn btn-xs btn-outline-secondary btn-rounded m-1"
                                                (click)="share(result)"
                                            >
                                                Trimite
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TAB 2: Detalii rezultat -->
            <div *ngIf="!showHistory && selectedResult">
                <div class="card dashboard-card results-card mb-4">
                    <div class="card-header text-white">
                        <div
                            class="d-flex justify-content-between align-items-center"
                        >
                            <h5 class="mb-1">Detalii rezultat</h5>
                            <button
                                type="button"
                                class="btn btn-light btn-sm btn-rounded"
                                (click)="backToHistory()"
                            >
                                <span class="icon bx bx-left-arrow-alt"></span>
                                Înapoi la istoric
                            </button>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-12">
                                <h6>Analiza efectuata</h6>
                                <p class="summary">
                                    {{ selectedResult.analysisType }}

                                    <small>
                                        Data:
                                        {{
                                            selectedResult.date
                                                | date: "dd.MM.yyyy"
                                        }}
                                        • Doctor:
                                        {{ selectedResult.doctorName }} •
                                        {{
                                            selectedResult.senderSpecialisation
                                        }}
                                    </small>
                                </p>
                            </div>
                        </div>

                        <!-- Info rezumat -->
                        <div class="row mb-3">
                            <div class="col-md-4">
                                <div class="info-label">Pacient</div>
                                <div class="info-value">
                                    {{ user.name || "-" }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="info-label">Unitate medicală</div>
                                <div class="info-value">
                                    {{
                                        selectedResult.hospitalName ||
                                            "Spital CF Pașcani"
                                    }}
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="info-label">Status</div>
                                <div class="info-value">
                                    <span
                                        class="badge"
                                        [ngClass]="
                                            selectedResult.status
                                                ? 'bg-success'
                                                : 'bg-danger'
                                        "
                                    >
                                        {{
                                            selectedResult.status
                                                ? "Finalizat"
                                                : "În lucru"
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- RADIOLOGY -->
                        <ng-container
                            *ngIf="
                                selectedResult?.category === 'RADIOLOGY';
                                else nonRadiologyDetails
                            "
                        >
                            <div class="row g-3 mt-1">
                                <div class="col-md-6">
                                    <div class="border rounded p-3 h-100">
                                        <div class="fw-bold mb-1">Număr</div>
                                        <div>
                                            {{
                                                getValue(
                                                    getElement(
                                                        selectedResult,
                                                        'SRII00100'
                                                    )
                                                ) || "-"
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="border rounded p-3 h-100">
                                        <div class="fw-bold mb-1">Data</div>
                                        <div>
                                            {{
                                                getValue(
                                                    getElement(
                                                        selectedResult,
                                                        'SRII00110'
                                                    )
                                                ) || "-"
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="border rounded p-3">
                                        <div class="fw-bold mb-3">
                                            Persoana
                                        </div>

                                        <div class="row g-3">
                                            <div class="col-md-4">
                                                <div class="text-muted small">
                                                    Nume
                                                </div>
                                                <div>
                                                    {{
                                                        getValue(
                                                            getChildElement(
                                                                getElement(
                                                                    selectedResult,
                                                                    'SRII00200'
                                                                ),
                                                                'SRII00201'
                                                            )
                                                        ) || "-"
                                                    }}
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="text-muted small">
                                                    Prenume
                                                </div>
                                                <div>
                                                    {{
                                                        getValue(
                                                            getChildElement(
                                                                getElement(
                                                                    selectedResult,
                                                                    'SRII00200'
                                                                ),
                                                                'SRII00202'
                                                            )
                                                        ) || "-"
                                                    }}
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="text-muted small">
                                                    Sex
                                                </div>
                                                <div>
                                                    {{
                                                        getValue(
                                                            getChildElement(
                                                                getElement(
                                                                    selectedResult,
                                                                    'SRII00200'
                                                                ),
                                                                'SRII00203'
                                                            )
                                                        ) || "-"
                                                    }}
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="text-muted small">
                                                    Vârstă
                                                </div>
                                                <div>
                                                    {{
                                                        getValue(
                                                            getChildElement(
                                                                getElement(
                                                                    selectedResult,
                                                                    'SRII00200'
                                                                ),
                                                                'SRII00204'
                                                            )
                                                        ) || "-"
                                                    }}
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="text-muted small">
                                                    CNP
                                                </div>
                                                <div>
                                                    {{
                                                        getValue(
                                                            getChildElement(
                                                                getElement(
                                                                    selectedResult,
                                                                    'SRII00200'
                                                                ),
                                                                'SRII00205'
                                                            )
                                                        ) || "-"
                                                    }}
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="text-muted small">
                                                    Județ / Sector
                                                </div>
                                                <div>
                                                    {{
                                                        getValue(
                                                            getChildElement(
                                                                getChildElement(
                                                                    getElement(
                                                                        selectedResult,
                                                                        'SRII00200'
                                                                    ),
                                                                    'SRII00206'
                                                                ),
                                                                'SRII002061'
                                                            )
                                                        ) || "-"
                                                    }}
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="text-muted small">
                                                    Localitatea
                                                </div>
                                                <div>
                                                    {{
                                                        getValue(
                                                            getChildElement(
                                                                getChildElement(
                                                                    getElement(
                                                                        selectedResult,
                                                                        'SRII00200'
                                                                    ),
                                                                    'SRII00206'
                                                                ),
                                                                'SRII002062'
                                                            )
                                                        ) || "-"
                                                    }}
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="text-muted small">
                                                    Adresa
                                                </div>
                                                <div>
                                                    {{
                                                        getValue(
                                                            getChildElement(
                                                                getChildElement(
                                                                    getElement(
                                                                        selectedResult,
                                                                        'SRII00200'
                                                                    ),
                                                                    'SRII00206'
                                                                ),
                                                                'SRII002063'
                                                            )
                                                        ) || "-"
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="border rounded p-3 h-100">
                                        <div class="fw-bold mb-1">
                                            Bilet de trimitere
                                        </div>
                                        <div>
                                            {{
                                                getValue(
                                                    getElement(
                                                        selectedResult,
                                                        'SRII00700'
                                                    )
                                                ) || "-"
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="border rounded p-3 h-100">
                                        <div class="fw-bold mb-1">
                                            Trimis de
                                        </div>
                                        <div>
                                            {{
                                                getValue(
                                                    getElement(
                                                        selectedResult,
                                                        'SRII00300'
                                                    )
                                                ) || "-"
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="border rounded p-3 h-100">
                                        <div class="fw-bold mb-1">
                                            Regiunea de examinat
                                        </div>
                                        <div>
                                            {{
                                                getValue(
                                                    getElement(
                                                        selectedResult,
                                                        'SRII00400'
                                                    )
                                                ) || "-"
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="border rounded p-3 h-100">
                                        <div class="fw-bold mb-1">
                                            Diagnostic clinic / cod
                                        </div>
                                        <div>
                                            {{
                                                getValue(
                                                    getElement(
                                                        selectedResult,
                                                        'SRII00500'
                                                    )
                                                ) || "-"
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="border rounded p-3">
                                        <div class="fw-bold mb-2">
                                            Rezultatul examinării
                                        </div>
                                        <div
                                            [innerHTML]="
                                                getValue(
                                                    getElement(
                                                        selectedResult,
                                                        'SRII00600'
                                                    )
                                                ) || '-'
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- NON RADIOLOGY -->
                        <ng-template #nonRadiologyDetails>
                            <!-- Grupuri de analize -->
                            <div
                                *ngIf="
                                    selectedResult.resultGroupList &&
                                    selectedResult.resultGroupList.length > 0;
                                    else emptyDetails
                                "
                            >
                                <h6 class="section-subtitle mb-3">
                                    Detalii analize medicale
                                </h6>
                                <div
                                    class="container-fluid tabel-analize"
                                    *ngFor="
                                        let group of selectedResult.resultGroupList;
                                        let isLast = last
                                    "
                                >
                                    <div
                                        class="row"
                                        *ngFor="let item of group.resultItemList"
                                        [ngClass]="item.normal ? '' : 'warn'"
                                    >
                                        <div class="col-md-6">
                                            <strong>{{
                                                item.labelForItem || item.code
                                            }}</strong>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            {{ item.stringValue || "-" }}
                                            <small class="text-muted">
                                                {{ item.measureUnit || "-" }}
                                            </small>
                                        </div>
                                        <div class="col-md-3 col-6">
                                            {{ item.referenceValue || "-" }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Mesaj dacă nu există grupuri -->
                        <ng-template #emptyDetails>
                            <div
                                class="text-center text-muted py-4"
                            >
                                <i
                                    class="bx bx-info-circle"
                                    style="font-size: 2rem"
                                ></i>
                                <p class="mt-2">
                                    Nu există detalii disponibile pentru acest
                                    rezultat.
                                </p>
                            </div>
                        </ng-template>

                        <!-- Acțiuni jos -->
                        <div *ngIf="selectedResult.downloadReference"
                            class="mt-4 d-flex flex-wrap gap-2 justify-content-end"
                        >
                            <button
                                type="button"
                                class="btn btn-outline-primary btn-sm btn-rounded"
                                (click)="download(selectedResult)"
                            >
                                <i class="bx bx-download"></i> Descarcă PDF
                            </button>
                            <button
                                type="button"
                                class="btn btn-outline-secondary btn-sm btn-rounded"
                                (click)="share(selectedResult)"
                            >
                                <i class="bx bx-share-alt"></i> Trimite
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Share - adaugă după butoanele de acțiuni -->
        <div
            class="modal fade show"
            *ngIf="showingShareModal"
            tabindex="-1"
            style="display: block; background: rgba(0, 0, 0, 0.5)"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-gradient-success text-white">
                        <h5 class="modal-title">
                            <i class="bx bx-share-alt me-2"></i>
                            Link de partajare generat
                        </h5>
                        <button
                            type="button"
                            class="btn-close btn-close-black"
                            (click)="closeShareModal()"
                        ></button>
                    </div>

                    <div class="modal-body">
                        <div class="alert alert-success">
                            <i class="bx bx-check-circle me-2"></i>
                            Link-ul este valid până la:
                            <strong>{{ shareExpiresAt }}</strong>
                        </div>

                        <div class="d-flex gap-2">
                            <button
                                class="btn btn-success w-100"
                                (click)="openShareLink()"
                            >
                                <i class="bx bx-link-external"></i> Deschide
                                link
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>